import { styled } from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const ServerSideErrorPageContent = styled.div`
    max-width: 42rem;
    margin: ${getPurpurSpacing('600')} auto 0;
    padding: 0 ${getPurpurSpacing('200')};
`;

export const ServerSideErrorPageList = styled.ul`
    margin: ${getPurpurSpacing('250')} 0 0;
    padding: 0;
    list-style-type: none;
`;

export const ServerSideErrorPageDivider = styled.hr`
    margin: ${getPurpurSpacing('600')} 0 0;
`;

export const ErrorBlockWrapper = styled.div`
    margin-top: ${getPurpurSpacing('400')};
    margin-bottom: ${getPurpurSpacing('400')};
`;
